import type { ReactElement } from 'react';

type Props = { url: string };

function extractYouTubeId(url: string): string | null {
  const match = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]{11})/);
  return match?.[1] ?? null;
}

export function YouTubeEmbed({ url }: Props): ReactElement {
  const videoId = extractYouTubeId(url);
  if (!videoId) {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer" className="text-sm text-primary hover:underline">
        {url}
      </a>
    );
  }
  return (
    <div className="aspect-video rounded-lg overflow-hidden">
      <iframe
        title="YouTube video"
        src={`https://www.youtube-nocookie.com/embed/${videoId}`}
        className="w-full h-full"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
}
